import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { APIReferenceErrorResponsePage } from 'src/app/model/shared/api-reference-error-responses-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { PageVersionService } from 'src/app/service/page-version.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-api-reference-error-responses-page',
  templateUrl: './api-reference-error-responses-page.component.html',
  styleUrls: ['./api-reference-error-responses-page.component.scss']
})
export class APIReferenceErrorResponsesPageComponent implements OnInit, OnDestroy {
  @Input() pageName = '';
  pageVersions: string[] = [];
  pageVersionServiceSubscription: any;
  apiReferenceErrorResponsePage: APIReferenceErrorResponsePage = {} as APIReferenceErrorResponsePage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService, private pageVersionService: PageVersionService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'api-reference-error-response') {
        this.apiReferenceErrorResponsePage.htmlTitle = title.htmlTitle;
      }
    });
    const versionQuery = { 'fields.title': this.pageName, select: 'sys.id,fields.version' };

    this.contentfulService.getPageVersions(versionQuery).then((orderRetrieveItems) => {
      this.pageVersions = orderRetrieveItems
        .filter((item: { fields: undefined }) => item.fields !== undefined)
        .map((item: { fields: { version: string } }) => item.fields.version)
        .sort();

      let selectedPageVersion = '';
      if (this.pageVersions.length > 0) {
        selectedPageVersion = this.pageVersions[0];
        // console.log(this.pageName + ' >>>> default page version : ' + selectedPageVersion);
      }

      // console.log('default selectedPageVersion : ', selectedPageVersion);
      this.getPageContentFromContentful(selectedPageVersion);
    });

    this.pageVersionServiceSubscription = this.pageVersionService.pageVersion.subscribe((pageVersionData) => {
      if (pageVersionData.pageName === this.pageName && pageVersionData.selectedPageVersion !== undefined && pageVersionData.selectedPageVersion !== '') {
        // console.log('pageVersionData : ', pageVersionData);
        this.getPageContentFromContentful(pageVersionData.selectedPageVersion);
      }
    });
  }

  getPageContentFromContentful(selectedPageVersion: string) {
    // console.log(this.pageName + ' >>>> select page version : ' + selectedPageVersion);

    const query = selectedPageVersion === '' ? { 'fields.title': this.pageName } : { 'fields.title': this.pageName, 'fields.version': selectedPageVersion };
    this.contentfulService.getPageContentResponse(query).then((orderRetrievePageResponse) => {
      this.apiReferenceErrorResponsePage.tableSections = [];
      this.mapBanner(orderRetrievePageResponse.includes.Entry);
      this.apiReferenceErrorResponsePage.banner.pageName = this.pageName;
      this.apiReferenceErrorResponsePage.banner.pageVersions = this.pageVersions;
      this.apiReferenceErrorResponsePage.banner.defaultPageVersion = selectedPageVersion;
      this.sharedDataService.addSharedData(this.apiReferenceErrorResponsePage.banner);
      // console.log(this.pageName + ' >>>> >>>> banner.pageVersions : ' + this.apiReferenceErrorResponsePage.banner.pageVersions);
      this.mapPageInfo(orderRetrievePageResponse.items);
      this.mapTableSection(orderRetrievePageResponse.includes.Entry);
    });
  }

  private mapBanner(orderRetrieveBannerEntry: Entry<any>[]) {
    orderRetrieveBannerEntry
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {

    
    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];

    this.apiReferenceErrorResponsePage.banner ={      
      title: pageTitle,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.apiReferenceErrorResponsePage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.apiReferenceErrorResponsePage.banner.url = entry.fields?.url;
      this.apiReferenceErrorResponsePage.banner.editorEmail = editorDetails?.pop();
      this.apiReferenceErrorResponsePage.banner.editorShortName = editorDetails?.pop();
      this.apiReferenceErrorResponsePage.banner.editorFullName = editorDetails?.pop();
      this.apiReferenceErrorResponsePage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapTableSection(orderListTableEntrySection: Entry<any>[]) {
    orderListTableEntrySection
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
      });
  }

  private mapEntryToTableSection(entry: Entry<any>) {

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#')[2];

    this.apiReferenceErrorResponsePage.tableSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      table: entry.fields['table'] as string
    });
    this.apiReferenceErrorResponsePage.tableSections.sort((a, b) => a.order - b.order);
  }

  ngOnDestroy() {
    this.pageVersionServiceSubscription.unsubscribe();
  }
}
